import './test.css';
import B from './components/B';
// import C from './components/C';
import D from './components/D';
// import E from './components/E';
// import F from './components/F';
import G from './components/G';
// import O from './components/O';
// import P from './components/P';
// import Q from './components/Q';
// import S from './components/S';
// import T from './components/T';
import R from './components/R';
import Banner from './new-components/Banner';
import Stops from './new-components/Stops';
import Emergency from './new-components/Emergency';
import UserTrust from './new-components/UserTrust';
import GlobalNum1 from './new-components/GlobalNum1';
import Through from './new-components/Through';
import Stories from './new-components/Stories';
import TrustedTetailers from './new-components/TrustedTetailers';
import FreeQuote from './new-components/FreeQuote';
import getLocal from '@/app/utils/i18n';

export default function IndexDynamic() {
    const { locale = 'us' } = getLocal();

    return (
        <>
            {locale === 'us' && <FreeQuote />}
            <Banner />
            <Stops />
            <Emergency />
            <UserTrust />
            <B />
            <D />
            <TrustedTetailers />
            <G />
            <GlobalNum1 />
            <Stories />
            <Through />
            <R />

            <div className="page-space"></div>
            {/* 
            <Q />
            <C />
            
            <S />
            <F />
            
            <T />
             */}
            {/* <div className="white-section">
                <P />
            </div> */}
        </>
    );
}
